import React from 'react'
import PropTypes from 'prop-types'

import { getAverageBias, calculateBiasForLevel, isQcComplete, getCV } from '../../../store/qc'
import _ from 'lodash'

const BIAS_TARGET = 7.5
const CV_TARGET = 10

class StatsView extends React.Component {
  static propTypes = {
    qcResults: PropTypes.shape({
      low_jobs: PropTypes.arrayOf(PropTypes.shape({
        job_id: PropTypes.number
      })),
      normal_jobs: PropTypes.arrayOf(PropTypes.shape({
        job_id: PropTypes.number
      })),
      high_jobs: PropTypes.arrayOf(PropTypes.shape({
        job_id: PropTypes.number
      }))
    }),
    controlMaterial: PropTypes.shape({
      low: PropTypes.shape({}),
      normal: PropTypes.shape({}),
      high: PropTypes.shape({})
    })
  }

  static defaultProps = {
    qcResults: {
      low_jobs: [],
      normal_jobs: [],
      high_jobs: []
    },
    controlMaterial: {
      low: {},
      normal: {},
      high: {}
    }
  }

  render () {
    const { qcResults, controlMaterial } = this.props
    const isQcFinished = isQcComplete(qcResults)
    let lowBias = _.round(calculateBiasForLevel(qcResults, 'low', controlMaterial) * 100, 1)
    lowBias = _.isNaN(lowBias) ? 'N/A' : lowBias
    let normalBias = _.round(calculateBiasForLevel(qcResults, 'normal', controlMaterial) * 100, 1)
    normalBias = _.isNaN(normalBias) ? 'N/A' : normalBias
    let highBias = _.round(calculateBiasForLevel(qcResults, 'high', controlMaterial) * 100, 1)
    highBias = _.isNaN(highBias) ? 'N/A' : highBias

    let averageBias = _.round(getAverageBias(qcResults, controlMaterial) * 100, 1) // multiply by 100 to get a percentage
    if (_.isNaN(averageBias)) {
      averageBias = 0
    }
    let lowJobsCV = _.round(getCV(qcResults, 'low') * 100, 1)
    let normalJobsCV = _.round(getCV(qcResults, 'normal') * 100, 1)
    let highJobsCV = _.round(getCV(qcResults, 'high') * 100, 1)

    const passed = averageBias < BIAS_TARGET &&
      lowJobsCV < CV_TARGET &&
      normalJobsCV < CV_TARGET &&
      highJobsCV < CV_TARGET

    return (
      <div style={{ paddingTop: 20 }} className='html2pdf-break-before'>
        <h5>Result Statistics</h5>
        <table className='table table-bordered'>
          <thead className='thead-light'>
            <tr>
              <th scope='col'>Statistic</th>
              <th scope='col'>Value</th>
              <th scope='col'>Target</th>
              <th scope='col'>Passed</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Low Bias</td>
              <td>{lowBias}%</td>
              <td>-</td>
              <td>-</td>
            </tr>

            <tr>
              <td>Normal Bias</td>
              <td>{normalBias}%</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr>
              <td>High Bias</td>
              <td>{highBias}%</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr>
              <td>Average Bias</td>
              <td>{averageBias}%</td>
              <td>{BIAS_TARGET}%</td>
              <td>{averageBias < BIAS_TARGET ? 'Yes' : 'No'}</td>
            </tr>
            <tr>
              <td>Low CV</td>
              <td>{lowJobsCV}%</td>
              <td>{CV_TARGET}%</td>
              <td>{lowJobsCV < CV_TARGET ? 'Yes' : 'No'}</td>
            </tr>

            <tr>
              <td>Normal CV</td>
              <td>{normalJobsCV}%</td>
              <td>{CV_TARGET}%</td>
              <td>{normalJobsCV < CV_TARGET ? 'Yes' : 'No'}</td>
            </tr>

            <tr>
              <td>High CV</td>
              <td>{highJobsCV}%</td>
              <td>{CV_TARGET}%</td>
              <td>{highJobsCV < CV_TARGET ? 'Yes' : 'No'}</td>
            </tr>
          </tbody>
        </table>
        <div>
          { !isQcFinished ? (
            <div className='alert alert-warning' role='alert'>
              Test Not Complete
            </div>
          ) : (passed
              ? <div className='alert alert-success' role='alert'>LVT {qcResults.test_strip_lot} Passed</div>
              : <div className='alert alert-danger' role='alert'>LVT {qcResults.test_strip_lot} Failed</div>
            )
          }
        </div>
      </div>
    )
  }
}

export default StatsView



// WEBPACK FOOTER //
// ./src/routes/QC/components/StatsView.jsx